import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import styles from './RequireInfoModal.scss'
import { challengeMessages } from '../../intlMessages'
import { messages as cspMessages } from '../../ChallengeShowPage'
import { CircleSpinner } from 'common/spinners/CircleSpinner'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { loginMessages } from 'common/styleguide/LoginModal'
import { CTA } from 'common/styleguide/CTA'
import { useFormatMessage, commonCTAs } from 'lib/localization'
import { errorMessage } from 'lib/styleguide/base.scss'
import { urlWithPrivacyCode } from 'lib/utils'
import { userActions, userSelectors } from 'data/resources/users'
import { defineMessages } from 'react-intl'
import { Map } from 'immutable'

export const REQUIRE_INFO_MODAL = 'REQUIRE_INFO_MODAL'

const messages = defineMessages({
  youProvide: {
    id: 'RequireInfoModal.youProvide',
    defaultMessage: 'You must provide your name and email address to join this Challenge.'
  },
  disclaimer: {
    id: 'RequireInfoModal.disclaimer',
    defaultMessage: 'By creating an account you are accepting our <a1>Terms of Service</a1> and <a2>Privacy Policy</a2>. We may occasionally send you emails with product updates, and you can unsubscribe at any time.'
  }
})

export const _RequireInfoModal = ({ goal, user, fetchUser, updateUser, joinGoal, onRequestClose, ...props }) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(Map({ firstName: false, lastName: false, email: false }))
  const [pendingEdits, setPendingEdits] = useState(Map())
  useEffect(() => {
    fetchUser().then(() => setLoading(false))
  }, [])

  const setPendingEdit = async (key, value) => { await setPendingEdits(pendingEdits.set(key, value)) }
  const fm = useFormatMessage()
  const values = user.merge(pendingEdits)
  const isEmpty = val => !val || val === ''
  const onSubmit = () => {
    if (isEmpty(values.get('firstName')) || isEmpty(values.get('lastName')) || isEmpty(values.get('email'))) {
      setError(Map({
        firstName: isEmpty(values.get('firstName')),
        lastName: isEmpty(values.get('lastName')),
        email: isEmpty(values.get('email'))
      }))
      return
    }

    if (
      pendingEdits.get('firstName') !== user.get('firstName') ||
      pendingEdits.get('lastName') !== user.get('lastName') ||
      pendingEdits.get('email') !== user.get('email')
    ) {
      updateUser(user.id, { user: {
        ...Object.assign({},
          pendingEdits.get('firstName') && { firstName: pendingEdits.get('firstName') },
          pendingEdits.get('lastName') && { lastName: pendingEdits.get('lastName') },
          pendingEdits.get('email') && { email: pendingEdits.get('email') }
        )
      } })
    }

    joinGoal()
      .then(() => {
        // remove ?autojoin param
        window.location = urlWithPrivacyCode(window.location.pathname, goal.privacyCode)
      })
    onRequestClose()
  }

  return (
    <ConfirmationDialog
      title={goal.name}
      subtitle={<div style={{ color: '#757575' }}>{fm(messages.youProvide)}</div>}
      noFooter
      maxWidth='380px'
      onRequestClose={onRequestClose}
      confirmText={fm(commonCTAs.close)}
      onConfirm={onRequestClose}>
      {loading
        ? <CircleSpinner centered size={40} />
        : <>
          <form onSubmit={onSubmit}>
            <label>
              {fm(challengeMessages.firstName)}
              <input className={error.get('firstName') ? errorMessage : undefined} value={values.get('firstName')} onChange={e => setPendingEdit('firstName', e.target.value)} />
            </label>
            <label>
              {fm(challengeMessages.lastName)}
              <input className={error.get('lastName') ? errorMessage : undefined} value={values.get('lastName')} onChange={e => setPendingEdit('lastName', e.target.value)} />
            </label>
            <label>
              {fm(loginMessages.email)}
              <input className={error.get('email') ? errorMessage : undefined} value={values.get('email')} onChange={e => setPendingEdit('email', e.target.value)} />
            </label>
          </form>
          <CTA onClick={onSubmit}>{fm(cspMessages.joinChallenge)}</CTA>
          <div className={styles.disclaimer}>
            {fm(messages.disclaimer, {
              a1: (...c) => <b><a href='/terms'>{c}</a></b>,
              a2: (...c) => <b><a href='/privacy'>{c}</a></b>
            })}
          </div>
        </>}
    </ConfirmationDialog>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: userSelectors.find(state, ownProps.currentUserId)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateUser: (id, params) => dispatch(userActions.update(id, params)),
    fetchUser: () => dispatch(userActions.read(ownProps.currentUserId))
  }
}

export const RequireInfoModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(_RequireInfoModal)
